<template>
    <div class="exam-attempts-report">
        <div class="section pt-1" v-if="isQhls">
            <div class="stat-grid">
                <div class="stat-box">
                    <div class="title mal-text">ആകെ പരീക്ഷ കേന്ദ്രങ്ങൾ</div>
                    <div class="value">{{ summary.total_centers }}</div>
                    <button
                        type="button"
                        class="stat-export-btn"
                        :disabled="!summary.total_centers || isCardExporting('total_centers')"
                        @click="exportCardExcel('total_centers')"
                    >
                        {{ isCardExporting('total_centers') ? '...' : 'Excel' }}
                    </button>
                </div>
                <div class="stat-box stat-box--clickable" @click="openCandidatesForScope('state', 'centers_attended')">
                    <div class="title mal-text">പരീക്ഷ എഴുതിയ കേന്ദ്രങ്ങൾ</div>
                    <div class="value text-success">{{ summary.centers_attended }}</div>
                    <button
                        type="button"
                        class="stat-export-btn"
                        :disabled="!summary.centers_attended || isCardExporting('centers_attended')"
                        @click.stop="exportCardExcel('centers_attended')"
                    >
                        {{ isCardExporting('centers_attended') ? '...' : 'Excel' }}
                    </button>
                </div>
                <div class="stat-box stat-box--clickable" @click="openCandidatesForScope('state', 'centers_not_attended')">
                    <div class="title mal-text">പരീക്ഷ എഴുതാത്ത കേന്ദ്രങ്ങൾ</div>
                    <div class="value text-warning">{{ summary.centers_not_attended }}</div>
                    <button
                        type="button"
                        class="stat-export-btn"
                        :disabled="!summary.centers_not_attended || isCardExporting('centers_not_attended')"
                        @click.stop="exportCardExcel('centers_not_attended')"
                    >
                        {{ isCardExporting('centers_not_attended') ? '...' : 'Excel' }}
                    </button>
                </div>
                <div
                    class="stat-box"
                    :class="{ 'stat-box--clickable': summary.candidates_attended > 0 && canOpenCandidatesSummary }"
                    @click="openCandidatesSummaryAttended"
                >
                    <div class="title mal-text">ആകെ പരീക്ഷ എഴുതിയവർ</div>
                    <div class="value text-primary">{{ summary.candidates_attended }}</div>
                    <button
                        type="button"
                        class="stat-export-btn"
                        :disabled="!summary.candidates_attended || isCardExporting('exam_attempts')"
                        @click.stop="exportCardExcel('exam_attempts')"
                    >
                        {{ isCardExporting('exam_attempts') ? '...' : 'Excel' }}
                    </button>
                </div>
                <div class="stat-box">
                    <div class="title mal-text">പരീക്ഷ എഴുതാത്തവർ</div>
                    <div class="value text-muted">{{ summary.candidates_not_attended }}</div>
                    <button
                        type="button"
                        class="stat-export-btn"
                        :disabled="!summary.candidates_not_attended || isCardExporting('candidates_not_attended')"
                        @click.stop="exportCardExcel('candidates_not_attended')"
                    >
                        {{ isCardExporting('candidates_not_attended') ? '...' : 'Excel' }}
                    </button>
                </div>
                <div class="stat-box">
                    <div class="title mal-text">ആകെ രജിസ്റ്റർ ചെയ്തവർ</div>
                    <div class="value">{{ totalCandidates }}</div>
                    <button
                        type="button"
                        class="stat-export-btn"
                        :disabled="!totalCandidates || isCardExporting('total_registrations')"
                        @click.stop="exportCardExcel('total_registrations')"
                    >
                        {{ isCardExporting('total_registrations') ? '...' : 'Excel' }}
                    </button>
                </div>
            </div>
        </div>
        <div class="section pt-1" v-else>
            <div class="row mt-1">
                <div class="col-12">
                    <div
                        class="stat-box"
                        :class="{ 'stat-box--clickable': count_total > 0 }"
                        @click="openCandidatesForScope('state')"
                    >
                        <div class="title mal-text">പരീക്ഷ എഴുതിയവർ (Total)</div>
                        <div class="value text-primary">{{ count_total }}</div>
                    </div>
                </div>
            </div>
        </div>

        <div id="search" class="section pt-0">
            <form class="search-form" v-if="!isQhls">
                <label class="label text-primary" style="margin-bottom:0px;" for="year"><span>വർഷം</span></label>
                <div class="form-group searchbox mal-text">
                    <select id="year" class="form-control custom-select" v-model="year" @change="fetchReport">
                        <option v-for="y in yearOptions" :key="y" :value="y">{{ y }}</option>
                    </select>
                    <i class="input-icon"><ion-icon name="calendar-outline"></ion-icon></i>
                </div>
            </form>
            <form class="search-form" v-if="exams && exams.length">
                <label class="label text-primary" style="margin-bottom:0px;" for="exam"><span>പരീക്ഷ</span></label>
                <div class="form-group searchbox mal-text">
                    <select id="exam" class="form-control custom-select" v-model="exam_id" @change="fetchReport">
                        <option value="">എല്ലാം</option>
                        <option v-for="exam in exams" :key="exam.id" :value="exam.id">{{ exam.name || 'Exam ' + exam.id }}</option>
                    </select>
                    <i class="input-icon"><ion-icon name="school-outline"></ion-icon></i>
                </div>
            </form>
            <form class="search-form" v-if="showDistrictFilter">
                <label class="label text-primary" style="margin-bottom:0px;"><span>ജില്ല (Org)</span></label>
                <div class="form-group searchbox mal-text">
                    <select class="form-control custom-select" v-model="filter_district" @change="onDistrictFilterChange">
                        <option value="">എല്ലാം</option>
                        <option v-for="district in district_list" :key="district.id" :value="district.id">
                            {{ district.name }}
                        </option>
                    </select>
                    <i class="input-icon"><ion-icon name="filter-outline"></ion-icon></i>
                </div>
            </form>
            <form class="search-form" v-if="showZoneFilter">
                <label class="label text-primary" style="margin-bottom:0px;"><span>മണ്ഡലം (Org)</span></label>
                <div class="form-group searchbox mal-text">
                    <select class="form-control custom-select" v-model="filter_zone" @change="onZoneFilterChange" :disabled="loading_zones">
                        <option value="">എല്ലാം</option>
                        <option v-for="zone in zone_list" :key="zone.id" :value="zone.id">
                            {{ zone.name }}
                        </option>
                    </select>
                    <i class="input-icon"><ion-icon name="filter-outline"></ion-icon></i>
                </div>
            </form>
            <form class="search-form" v-if="showCenterFilter">
                <label class="label text-primary" style="margin-bottom:0px;"><span>പരീക്ഷ കേന്ദ്രം</span></label>
                <div class="form-group searchbox mal-text">
                    <select class="form-control custom-select" v-model="filter_center" @change="fetchReport" :disabled="loading_centers">
                        <option value="">എല്ലാം</option>
                        <option v-for="center in center_list" :key="center.id" :value="center.id">
                            {{ centerLabel(center) }}
                        </option>
                    </select>
                    <i class="input-icon"><ion-icon name="location-outline"></ion-icon></i>
                </div>
            </form>
        </div>

        <div class="section pt-0 mt-0">
            <div class="listed-detail mt-3">
                <h3 class="text-center mt-2 mal-text custom-title mb-0">{{ page_title }}</h3>
            </div>
        </div>

        <div class="section text-center" v-if="loading_list">
            <div class="spinner-border text-secondary" role="status"></div>
        </div>

        <div class="listed-detail mt-0">
            <h4 class="text-center mt-0 mal-text" v-if="!loading_list && (!list || list.length === 0)">ഡാറ്റ ഇല്ല</h4>
        </div>

        <!-- QHLS: district / zone / center breakdown -->
        <div class="section mt-2 mb-2" v-if="isQhls && !loading_list && list && list.length > 0">
            <div class="card">
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col" class="mal-text">{{ listNameHeader }}</th>
                                <template v-if="list_type !== 'center'">
                                    <th scope="col" class="mal-text text-center">കേന്ദ്രം</th>
                                    <th scope="col" class="mal-text text-center">എഴുതിയ കേ.</th>
                                    <th scope="col" class="mal-text text-center">എഴുതിയില്ലാ. കേ.</th>
                                </template>
                                <th scope="col" class="mal-text text-center">എഴുതിയവർ</th>
                                <th scope="col" class="mal-text text-center">എഴുതാത്തവർ</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in list" :key="item.id || index">
                                <td class="text-muted">{{ index + 1 }}</td>
                                <td>
                                    <button
                                        type="button"
                                        class="btn btn-link p-0 mal-text row-name-btn"
                                        v-if="canDrillDownByFilter(item)"
                                        @click="drillDownByFilter(item)"
                                    >
                                        {{ item.name }}
                                    </button>
                                    <span v-else class="mal-text">{{ item.name }}</span>
                                    <span v-if="list_type === 'center' && item.center_status" class="badge ms-1" :class="item.centers_attended ? 'bg-success' : 'bg-secondary'">
                                        {{ item.center_status }}
                                    </span>
                                </td>
                                <template v-if="list_type !== 'center'">
                                    <td class="text-center text-muted">{{ item.total_centers || 0 }}</td>
                                    <td class="text-center">
                                        <button
                                            type="button"
                                            class="btn btn-link attempt-count-btn attempt-count-btn--sm p-0 text-success"
                                            :disabled="!(rowCentersAttended(item) > 0)"
                                            @click="openCandidatesForRow(item, 'centers_attended')"
                                        >
                                            {{ rowCentersAttended(item) }}
                                        </button>
                                    </td>
                                    <td class="text-center">
                                        <button
                                            type="button"
                                            class="btn btn-link attempt-count-btn attempt-count-btn--sm p-0 text-warning"
                                            :disabled="!(rowCentersNotAttended(item) > 0)"
                                            @click="openCandidatesForRow(item, 'centers_not_attended')"
                                        >
                                            {{ rowCentersNotAttended(item) }}
                                        </button>
                                    </td>
                                </template>
                                <td class="text-center">
                                    <button
                                        type="button"
                                        class="btn btn-link attempt-count-btn attempt-count-btn--sm p-0 text-success"
                                        :disabled="!(rowCandidatesAttended(item) > 0)"
                                        @click="openCandidatesForRow(item, 'candidates_attended')"
                                    >
                                        {{ rowCandidatesAttended(item) }}
                                    </button>
                                </td>
                                <td class="text-center">
                                    <button
                                        type="button"
                                        class="btn btn-link attempt-count-btn attempt-count-btn--sm p-0 text-muted"
                                        :disabled="!(rowCandidatesNotAttended(item) > 0) || list_type !== 'center'"
                                        @click="openCandidatesForRow(item, 'candidates_not_attended')"
                                    >
                                        {{ rowCandidatesNotAttended(item) }}
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <!-- QVP: district / zone drill-down -->
        <div class="section mt-2 mb-2" v-if="!isQhls && !loading_list && list && list.length > 0">
            <div class="card">
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col" class="mal-text">{{ listNameHeader }}</th>
                                <th scope="col" class="mal-text text-right">എണ്ണം</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in list" :key="item.id || index">
                                <td>{{ index + 1 }}</td>
                                <td>
                                    <router-link
                                        v-if="canDrillDownLink(item)"
                                        :to="drillDownPath(item)"
                                        class="text-primary mal-text"
                                    >
                                        {{ item.name }}
                                    </router-link>
                                    <span v-else class="mal-text">{{ item.name }}</span>
                                </td>
                                <td class="text-right">{{ item.attempt_count || 0 }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <!-- Candidates bottom sheet (same pattern as other action-sheet modals) -->
        <div class="modal fade action-sheet" id="examAttemptsCandidatesModal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title mal-text">{{ candidates_modal_title }}</h5>
                    </div>
                    <div class="modal-body">
                        <div class="action-sheet-content">
                            <div class="text-center py-3" v-if="loading_candidates">
                                <div class="spinner-border spinner-border-sm text-secondary" role="status"></div>
                            </div>
                            <p class="mal-text text-muted text-center mb-2" v-else-if="!candidates_list.length">
                                {{ candidatesEmptyMessage }}
                            </p>
                            <ul class="action-button-list" v-else>
                                <li v-for="(c, idx) in candidates_list" :key="c.registration_id || idx">
                                    <div class="btn btn-list candidate-info-row">
                                        <span class="candidate-info-row__inner">
                                            <span class="candidate-info-row__name mal-text">{{ c.name }}</span>
                                            <span class="candidate-info-row__meta" v-if="candidates_list_item_type === 'candidate' && c.mobile">
                                                {{ c.country_code ? c.country_code + ' ' : '' }}{{ c.mobile }}
                                            </span>
                                            <span class="candidate-info-row__meta" v-if="candidates_list_item_type === 'candidate' && c.age">
                                                പ്രായം: {{ c.age }}
                                            </span>
                                            <span class="candidate-info-row__meta" v-if="candidates_list_item_type === 'center' && c.mobile">
                                                {{ c.mobile }}
                                            </span>
                                        </span>
                                    </div>
                                </li>
                                <li class="action-divider"></li>
                                <li>
                                    <a href="#" class="btn btn-list text-danger" data-bs-dismiss="modal">
                                        <span>
                                            <ion-icon name="close-outline"></ion-icon> Cancel
                                        </span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UserService from "@/services/user.service";

export default {
    name: 'ExamAttemptsReport',
    data() {
        return {
            loading_list: false,
            loading_zones: false,
            loading_centers: false,
            loading_candidates: false,
            excel_card_export: '',
            list: [],
            count_total: 0,
            count_not_attended: 0,
            summary: {
                total_centers: 0,
                centers_attended: 0,
                centers_not_attended: 0,
                total_registrations: 0,
                exam_attempts: 0,
                candidates_attended: 0,
                candidates_not_attended: 0,
            },
            page_title: '',
            level: null,
            list_type: 'district',
            year: new Date().getFullYear().toString(),
            exam_id: '',
            exam_type: 'QVP',
            exams: [],
            user_level: null,
            district_list: [],
            zone_list: [],
            center_list: [],
            filter_district: '',
            filter_zone: '',
            filter_center: '',
            candidates_list: [],
            candidates_modal_title: 'പരീക്ഷ എഴുതിയവർ',
            candidates_list_item_type: 'candidate',
            candidates_list_mode: '',
        };
    },
    computed: {
        currentUser() {
            return this.$store && this.$store.state && this.$store.state.auth ? this.$store.state.auth.user : null;
        },
        yearOptions() {
            const y = new Date().getFullYear();
            return [y, y - 1, y - 2];
        },
        isQhls() {
            return String(this.exam_type || '').toUpperCase() === 'QHLS';
        },
        showDistrictFilter() {
            return this.isQhls && this.user_level === 1;
        },
        showZoneFilter() {
            return this.isQhls && (this.user_level === 1 || this.user_level === 2);
        },
        showCenterFilter() {
            if (!this.isQhls) return false;
            if (this.user_level === 3) return true;
            return !!this.filter_zone;
        },
        listNameHeader() {
            if (this.list_type === 'center') return 'പരീക്ഷ കേന്ദ്രം';
            if (this.list_type === 'zone') return 'മണ്ഡലം';
            return 'ജില്ല';
        },
        examRouteSuffix() {
            return this.exam_type ? '/' + this.exam_type : '';
        },
        totalCandidates() {
            return this.summary.total_registrations
                ?? ((this.summary.candidates_attended || 0) + (this.summary.candidates_not_attended || 0));
        },
        canOpenCandidatesSummary() {
            return this.list_type === 'center' && !!this.filter_center;
        },
        candidatesEmptyMessage() {
            if (this.candidates_list_item_type === 'center') {
                return 'കേന്ദ്രങ്ങളില്ല';
            }
            if (this.candidates_list_mode === 'candidates_not_attended') {
                return 'എഴുതാത്ത സ്ഥാനാർത്ഥികളില്ല';
            }
            return 'എഴുതിയ സ്ഥാനാർത്ഥികളില്ല';
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace('/');
            return;
        }
        this.user_level = parseInt(this.$route.params.sub_level, 10);
        const examParam = this.$route.params.exam || this.$route.query.exam;
        this.exam_type = String(examParam || 'QVP').toUpperCase();
        if (this.$root && this.$root.updateParent) {
            this.$root.updateParent(
                this.isQhls ? 'QHLS പരീക്ഷ എഴുതിയവർ റിപ്പോർട്ട്' : 'പരീക്ഷ എഴുതിയവർ റിപ്പോർട്ട്'
            );
        }
        if (this.isQhls) {
            if (this.user_level === 1) {
                this.loadOrgDistricts();
            } else if (this.user_level === 2) {
                this.getZoneList(parseInt(this.$route.params.id, 10));
            } else if (this.user_level === 3) {
                this.loadExamCenters();
            }
        }
        this.fetchReport();
    },
    methods: {
        centerLabel(center) {
            if (!center) return '';
            if (center.madrasa_name) return center.madrasa_name;
            if (center.convenor_name) return center.convenor_name;
            return 'Center #' + center.id;
        },
        loadOrgDistricts() {
            UserService.authPostRequest('get-district-by-id', {}).then(
                (response) => {
                    if (response.data.status === 'success') {
                        const raw = response.data.data.list;
                        this.district_list = Array.isArray(raw) ? raw : (raw ? [raw] : []);
                    } else {
                        this.district_list = [];
                    }
                },
                () => {
                    this.district_list = [];
                }
            );
        },
        resolveDistrictId() {
            if (this.user_level === 2) {
                return parseInt(this.$route.params.id, 10) || null;
            }
            return this.filter_district ? parseInt(this.filter_district, 10) : null;
        },
        examCenterRequestParams() {
            const params = {};
            const districtId = this.resolveDistrictId();
            if (this.filter_zone) {
                params.zone_id = this.filter_zone;
            } else if (this.user_level === 3) {
                const zoneId = parseInt(this.$route.params.id, 10);
                if (zoneId) params.zone_id = zoneId;
            } else if (districtId) {
                params.district_id = districtId;
            }
            return params;
        },
        loadExamCenters() {
            if (!this.showCenterFilter) {
                this.center_list = [];
                return;
            }
            const params = this.examCenterRequestParams();
            if (!params.zone_id && !params.district_id && this.user_level !== 1) {
                this.center_list = [];
                return;
            }
            this.loading_centers = true;
            UserService.authGetRequest('qhls-exam-centers', params).then(
                (response) => {
                    if (response.data.status === 'success' && Array.isArray(response.data.data?.list)) {
                        this.center_list = response.data.data.list;
                        if (this.filter_center && !this.center_list.some((c) => String(c.id) === String(this.filter_center))) {
                            this.filter_center = '';
                        }
                    } else {
                        this.center_list = [];
                    }
                    this.loading_centers = false;
                },
                () => {
                    this.center_list = [];
                    this.loading_centers = false;
                }
            );
        },
        onDistrictFilterChange() {
            this.filter_zone = '';
            this.filter_center = '';
            this.zone_list = [];
            this.center_list = [];
            if (this.filter_district) {
                this.getZoneList(this.filter_district);
            }
            this.fetchReport();
        },
        onZoneFilterChange() {
            this.filter_center = '';
            this.loadExamCenters();
            this.fetchReport();
        },
        getZoneList(district_id) {
            this.loading_zones = true;
            UserService.authPostRequest('get-zone-by-id', { district_id }).then(
                (response) => {
                    if (response.data.status === 'success') {
                        const raw = response.data.data.list;
                        this.zone_list = Array.isArray(raw) ? raw : (raw ? [raw] : []);
                    } else {
                        this.zone_list = [];
                    }
                    this.loading_zones = false;
                },
                () => {
                    this.zone_list = [];
                    this.loading_zones = false;
                }
            );
        },
        scopeTypeForRow() {
            if (this.list_type === 'center') return 'center';
            if (this.list_type === 'zone') return 'zone';
            return 'district';
        },
        buildCandidatesPayload(scopeType, scopeId, listMode = 'attended') {
            const data = {
                user_level: this.user_level,
                user_level_id: parseInt(this.$route.params.id, 10) || 0,
                exam_type: this.exam_type,
                scope_type: scopeType,
                list_mode: listMode,
            };
            if (scopeId) {
                data.scope_id = parseInt(scopeId, 10);
            }
            if (this.exam_id) {
                data.exam_id = parseInt(this.exam_id, 10);
            }
            const districtId = this.resolveDistrictId();
            if (districtId) data.district_id = districtId;
            if (this.filter_zone) data.zone_id = this.filter_zone;
            if (this.filter_center) data.qhls_exam_center_id = this.filter_center;
            return data;
        },
        openCandidatesModal() {
            const el = document.getElementById('examAttemptsCandidatesModal');
            if (el && window.bootstrap && window.bootstrap.Modal) {
                window.bootstrap.Modal.getOrCreateInstance(el).show();
            }
        },
        fetchCandidates(scopeType, scopeId, titleHint, listMode = 'centers_attended') {
            this.loading_candidates = true;
            this.candidates_list = [];
            this.candidates_list_mode = listMode;
            const titles = {
                centers_not_attended: 'പരീക്ഷ എഴുതാത്ത കേന്ദ്രങ്ങൾ',
                candidates_attended: 'ആകെ പരീക്ഷ എഴുതിയവർ',
                candidates_not_attended: 'പരീക്ഷ എഴുതാത്തവർ',
                centers_attended: 'പരീക്ഷ എഴുതിയ കേന്ദ്രങ്ങൾ',
            };
            this.candidates_modal_title = titleHint || titles[listMode] || 'പരീക്ഷ എഴുതിയവർ';
            this.openCandidatesModal();
            UserService.authPostRequest('get-exam-attempts-candidates', this.buildCandidatesPayload(scopeType, scopeId, listMode)).then(
                (response) => {
                    if (response.data.status === 'success' && response.data.data) {
                        this.candidates_list = response.data.data.candidates || [];
                        this.candidates_list_item_type = response.data.data.list_item_type || 'candidate';
                        this.candidates_modal_title = response.data.data.page_title || this.candidates_modal_title;
                    } else {
                        this.candidates_list = [];
                    }
                    this.loading_candidates = false;
                },
                (error) => {
                    this.loading_candidates = false;
                    this.candidates_list = [];
                    const msg = (error.response && error.response.data && error.response.data.message) || error.message || 'Error';
                    if (this.$toast) this.$toast.open(msg);
                    else alert(msg);
                }
            );
        },
        emptySummary() {
            return {
                total_centers: 0,
                centers_attended: 0,
                centers_not_attended: 0,
                total_registrations: 0,
                exam_attempts: 0,
                candidates_attended: 0,
                candidates_not_attended: 0,
            };
        },
        applySummaryFromResponse(data) {
            const s = data.summary || {};
            this.summary = {
                total_centers: s.total_centers ?? 0,
                centers_attended: s.centers_attended ?? data.count_total ?? 0,
                centers_not_attended: s.centers_not_attended ?? data.count_not_attended ?? 0,
                total_registrations: s.total_registrations ?? 0,
                exam_attempts: s.exam_attempts ?? s.candidates_attended ?? 0,
                candidates_attended: s.candidates_attended ?? s.exam_attempts ?? 0,
                candidates_not_attended: s.candidates_not_attended ?? 0,
            };
            this.count_total = this.summary.centers_attended;
            this.count_not_attended = this.summary.centers_not_attended;
        },
        rowCentersAttended(item) {
            return item.centers_attended ?? item.attempt_count ?? 0;
        },
        rowCentersNotAttended(item) {
            return item.centers_not_attended ?? item.not_attended_count ?? 0;
        },
        rowCandidatesAttended(item) {
            return item.candidates_attended ?? (this.list_type === 'center' ? item.attempt_count : 0) ?? 0;
        },
        rowCandidatesNotAttended(item) {
            return item.candidates_not_attended ?? (this.list_type === 'center' ? item.not_attended_count : 0) ?? 0;
        },
        summaryCountForListMode(listMode) {
            const map = {
                centers_attended: this.summary.centers_attended,
                centers_not_attended: this.summary.centers_not_attended,
                candidates_attended: this.summary.candidates_attended,
            };
            return map[listMode] || 0;
        },
        openCandidatesSummaryAttended() {
            if (!this.canOpenCandidatesSummary || this.summary.candidates_attended <= 0) return;
            this.fetchCandidates('center', this.filter_center, '', 'candidates_attended');
        },
        openCandidatesForScope(scopeType, listMode = 'centers_attended') {
            if (!this.isQhls) return;
            if (!['centers_attended', 'centers_not_attended'].includes(listMode)) return;
            if (this.summaryCountForListMode(listMode) <= 0) return;
            if (scopeType === 'state' && this.user_level !== 1) return;
            if (this.filter_center) return;
            if (this.filter_zone) {
                this.fetchCandidates('zone', this.filter_zone, '', listMode);
                return;
            }
            const districtId = this.resolveDistrictId();
            if (districtId) {
                this.fetchCandidates('district', districtId, '', listMode);
                return;
            }
            if (scopeType === 'state') {
                this.fetchCandidates('state', null, '', listMode);
            }
        },
        openCandidatesForRow(item, listMode = 'centers_attended') {
            if (!this.isQhls || !item) return;
            const scopeType = this.scopeTypeForRow();
            if (listMode === 'candidates_attended' || listMode === 'candidates_not_attended') {
                if (this.list_type !== 'center') return;
                const count = listMode === 'candidates_attended' ? this.rowCandidatesAttended(item) : this.rowCandidatesNotAttended(item);
                if (!(count > 0)) return;
                this.fetchCandidates('center', item.id, item.name, listMode);
                return;
            }
            const count = listMode === 'centers_not_attended' ? this.rowCentersNotAttended(item) : this.rowCentersAttended(item);
            if (!(count > 0)) return;
            this.fetchCandidates(scopeType, item.id, item.name, listMode);
        },
        canDrillDownByFilter(item) {
            if (!this.isQhls || !item || item.id == null) return false;
            return this.list_type === 'district' || this.list_type === 'zone';
        },
        drillDownByFilter(item) {
            if (!this.canDrillDownByFilter(item)) return;
            if (this.list_type === 'district') {
                this.filter_district = String(item.id);
                this.onDistrictFilterChange();
            } else if (this.list_type === 'zone') {
                this.filter_zone = String(item.id);
                this.onZoneFilterChange();
            }
        },
        canDrillDownLink(item) {
            if (!item || item.id == null) return false;
            return this.user_level != null && this.user_level <= 2;
        },
        drillDownPath(item) {
            const nextLevel = this.user_level + 1;
            return `/org/${nextLevel}/${item.id}/exam-attempts-report${this.examRouteSuffix}`;
        },
        buildRequestPayload() {
            const data = {
                user_level: this.user_level,
                user_level_id: parseInt(this.$route.params.id, 10) || 0,
                exam_type: this.exam_type,
            };
            if (!this.isQhls) {
                data.year = this.year;
            }
            if (this.exam_id) {
                data.exam_id = parseInt(this.exam_id, 10);
            }
            if (this.isQhls) {
                const districtId = this.resolveDistrictId();
                if (districtId) data.district_id = districtId;
                if (this.filter_zone) data.zone_id = this.filter_zone;
                if (this.filter_center) data.qhls_exam_center_id = this.filter_center;
            }
            return data;
        },
        isCardExporting(exportType) {
            return this.excel_card_export === exportType;
        },
        async exportCardExcel(exportType) {
            if (!this.isQhls || this.excel_card_export) return;
            this.excel_card_export = exportType;
            try {
                const payload = { ...this.buildRequestPayload(), export_type: exportType };
                const response = await UserService.authPostRequest(
                    'export-exam-attempts-report-excel',
                    payload,
                    { responseType: 'blob', timeout: 300000 }
                );
                const blob = response.data;
                const contentType = (response.headers && response.headers['content-type']) || '';
                if (contentType.indexOf('text/html') !== -1 || contentType.indexOf('application/json') !== -1) {
                    const text = await new Promise((res) => {
                        const r = new FileReader();
                        r.onload = () => res(r.result);
                        r.readAsText(blob);
                    });
                    const json = JSON.parse(text);
                    const msg = json.message || 'Download failed';
                    if (this.$toast) this.$toast.open(msg);
                    else alert(msg);
                    return;
                }
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `qhls-${exportType}-${new Date().toISOString().slice(0, 10)}.xlsx`;
                a.click();
                URL.revokeObjectURL(url);
            } catch (err) {
                let msg = 'Failed to export Excel';
                if (err.code === 'ECONNABORTED' || (err.message && err.message.indexOf('timeout') !== -1)) {
                    msg = 'Export timed out. Please try again or filter by district/zone.';
                } else if (err.response && err.response.status === 504) {
                    msg = 'Server timeout while generating Excel. Please deploy latest API or try a smaller filter.';
                } else if (err.response && err.response.data) {
                    if (err.response.data instanceof Blob) {
                        try {
                            const text = await err.response.data.text();
                            const json = JSON.parse(text);
                            msg = json.message || msg;
                        } catch (e) {
                            /* keep default */
                        }
                    } else if (err.response.data.message) {
                        msg = err.response.data.message;
                    }
                } else if (err.message) {
                    msg = err.message;
                }
                if (this.$toast) this.$toast.open(msg);
                else alert(msg);
            } finally {
                this.excel_card_export = '';
            }
        },
        fetchReport() {
            this.loading_list = true;
            UserService.authPostRequest('get-exam-attempts-report', this.buildRequestPayload()).then(
                (response) => {
                    if (response.data.status === 'success' && response.data.data) {
                        const data = response.data.data;
                        this.list = data.list || [];
                        this.applySummaryFromResponse(data);
                        this.page_title = data.page_title || 'പരീക്ഷ എഴുതിയവർ റിപ്പോർട്ട്';
                        this.level = data.level;
                        this.list_type = data.list_type || 'district';
                        this.exams = data.exams || [];
                    } else {
                        this.list = [];
                        this.summary = this.emptySummary();
                        this.count_total = 0;
                        this.count_not_attended = 0;
                        this.page_title = response.data.data ? (response.data.data.page_title || '') : '';
                    }
                    this.loading_list = false;
                },
                (error) => {
                    this.loading_list = false;
                    this.list = [];
                    this.summary = this.emptySummary();
                    this.count_total = 0;
                    this.count_not_attended = 0;
                    const msg = (error.response && error.response.data && error.response.data.message) || error.message || 'Error loading report';
                    if (this.$toast) this.$toast.open(msg);
                    else alert(msg);
                }
            );
        },
    },
};
</script>

<style scoped>
.stat-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    margin-top: 4px;
}
.stat-box {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 12px 14px;
    min-height: 118px;
    height: 100%;
    background: #fff;
    border: 1px solid #e8ecf1;
    border-radius: 10px;
    box-sizing: border-box;
}
.stat-box--clickable {
    cursor: pointer;
}
.stat-box .title {
    font-size: 13px;
    line-height: 1.4;
    min-height: 2.8em;
    margin-bottom: 8px;
    color: #374151;
    display: flex;
    align-items: flex-end;
}
.stat-box .value {
    font-size: 24px;
    font-weight: 700;
    letter-spacing: -0.02em;
    line-height: 1.1;
    color: #27173E;
    margin-top: auto;
}
.label {
    display: block;
    margin-bottom: 4px;
    font-size: 13px;
    font-weight: 600;
    color: #1a418c;
}
.attempt-count-btn {
    font-size: 22px;
    font-weight: 700;
    color: #1a418c;
    text-decoration: none;
}
.attempt-count-btn--sm {
    font-size: 18px;
}
.attempt-count-btn:disabled {
    color: #9ca3af;
    cursor: default;
}
.row-name-btn {
    font-weight: 600;
    text-align: left;
    color: #27173e;
}
.stat-box .value.text-success {
    color: #198754;
}
.stat-box .value.text-warning {
    color: #d97706;
}
.stat-box .value.text-muted {
    color: #6b7280;
}
.stat-export-btn {
    margin-top: 8px;
    width: 100%;
    padding: 4px 8px;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.2;
    color: #fff;
    background: #198754;
    border: none;
    border-radius: 6px;
    cursor: pointer;
}
.stat-export-btn:disabled {
    opacity: 0.45;
    cursor: not-allowed;
}
.stat-box--clickable .stat-export-btn {
    position: relative;
    z-index: 1;
}

/* Match standard bottom action-sheet size (not full-screen) */
#examAttemptsCandidatesModal .modal-body {
    max-height: 55vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
}
#examAttemptsCandidatesModal .action-sheet-content {
    padding-bottom: 0;
}
#examAttemptsCandidatesModal .candidate-info-row {
    pointer-events: none;
    height: auto;
    min-height: auto;
    padding-top: 10px;
    padding-bottom: 10px;
}
#examAttemptsCandidatesModal .candidate-info-row__inner {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    width: 100%;
}
#examAttemptsCandidatesModal .candidate-info-row__name {
    font-weight: 600;
    font-size: 15px;
    color: #27173e;
}
#examAttemptsCandidatesModal .candidate-info-row__meta {
    font-size: 12px;
    color: #6b7280;
    margin-top: 2px;
}
</style>
